export interface PlacementFilterConstants {
  siteTypes: { control: string; label: string }[];
  schoolTypes: string[];
  classTypes: string[];
  programList: string[];
}

export const PLACEMENT_FILTER_CONSTANTS: PlacementFilterConstants = {
  siteTypes: [
    {
      control: 'showByAvailableSeats',
      label: 'Show sites with available seats',
    },
    {
      control: 'isAccessibleSchoolRequired',
      label: 'Accessible School Required',
    },
  ],
  schoolTypes: [
    'Paraprofessional Recommended',
    'Nurse Recommended',
    'Restrict to student’s district',
    'Accessible School Required',
    'Sort schools by Building Accessibility Profile',
  ],
  classTypes: [
    'Deferred/Future Class',
    'Restrict 3 year age range',
    'Restrict math level',
    'Restrict reading level',
    'Show classes with available seats',
    'Show classes for student’s language',
    'Show classes that support student’s grade',
  ],
  programList: ['SCIS', 'SC'],
};
